<template>
  <div class="basic-details-wrapper">
    <div class="header">{{ newUser }}
      <h1 class="heading">Create An Account</h1>
    </div>
    <div class="main-form-area">
      <form @submit.prevent>
        <div class="container form-row-default">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6">
              <input
                type="text"
                class="auth-input-field"
                placeholder="First Name"
                autocomplete="given-name"
                v-model="newUser.firstname"
              />
            </div>
            <div class="col-12 col-md-6 col-lg-6">
              <input
                type="text"
                class="auth-input-field"
                placeholder="Last Name"
                autocomplete="family-name"
                v-model="newUser.lastname"
              />
            </div>
          </div>
        </div>

        <div class="container form-row-default">
          <div class="row">
            <div class="col-12 col-md-6 col-lg-6 padding-bottom-sm">
              <!-- <input
                @keypress="isNumber($event)"
                type="text"
                class="auth-input-field"
                placeholder="Work Mobile Number"
                autocomplete="phone"
                v-model="newUser.mobile_no"
              /> -->
              <vue-tel-input v-model="newUser.mobile_no" @keyup="validatePhone"></vue-tel-input>
              <div>
                <p>Phone number must be numeric values only</p>
              </div>
            </div>
            <div class="col-12 col-md-6 col-lg-6 padding-bottom-sm">
              <input
                type="text"
                class="auth-input-field"
                placeholder="Work Email Address"
                autocomplete="email"
                v-model="newUser.email"
              />
            </div>
          </div>
        </div>
        <div class="terms-service-agreement">
          <!-- <span class="checkbox-container"> -->
          <input type="checkbox" id="checkbox" v-model="newUser.checked" />
          <!-- </span> -->
          <label for="checkbox" class="text">
            I agree to the
            <a target="_blank" href="http://muleex-landing-new.s3-website.eu-west-2.amazonaws.com/userPolicies/termsAndCondition">Terms of Use</a>
            <span class="px-1">and</span>
            <a target="_blank" href="http://muleex-landing-new.s3-website.eu-west-2.amazonaws.com/userPolicies/privacyPolicy">Privacy Policy</a>.
          </label>
        </div>
        <div class="actions">
          <div class="btn-container">
            <div>{{ disableSignupButton }}
              <button
                class="btn bg-gray shadow text-primary-white"
                :disabled="disableSignupButton"
                @click="submitUserDetails"
              >
                <button-loader v-if="signingUserUp" />
                <span v-else>Sign Up</span>
              </button>
            </div>
            <div>
              <button
                class="sign-up--cloudenly_btn text-primary-black bg-primary-white no-outine"
              >
                <span class="pr-3">
                  <cloudenly-logo />
                </span>
                <span>Sign Up With Cloudenly</span>
              </button>
            </div>
          </div>
        </div>
      </form>
    </div>

    <div class="have-account">
      <small>
        Already have an account?
        <span>
          <router-link to="/login">Sign In</router-link>
        </span>
      </small>
    </div>

    <modal :showModal="showModal" @close-modal="showModal = false" width="35">
      <div class="confirm-email">
        <p class="text-sm text-center py-4">
          It looks like you are using a private e-mail. It is advisable to use a
          company's e-mail. Please confirm to continue or edit.
        </p>
        <div class="button-wrapper">
          <button
            class="button button-long confirm"
            @click="(showModal = false), (privateEmailConfirmed = true)"
          >
            Confirm
          </button>
          <button class="button-primary button button-long" @click="editEmail">
            Edit
          </button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import isNumber from "@/mixins/isNumber";
import CloudenlyLogo from "./CloudenlyLogo";
export default {
  components: {
    CloudenlyLogo,
  },
  data() {
    return {
      newUser: {
        firstname: "",
        lastname: "",
        mobile_no: "",
        email: "",
        checked: false,
      },
      showModal: false,
      signingUserUp: false,
      privateEmailConfirmed: false,
      userphoneerror : false,
      userphoneerrormsg : ""
    };
  },
  computed: {
    disableSignupButton() {
      let { firstname, lastname, mobile_no, email, checked } = this.newUser;
      let validate = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      let validEmail = validate.test(email);

      // let 

      let phone = mobile_no
      var patt = /[a-z]+/i

      if (
        firstname.length &&
        lastname.length &&
        mobile_no.length &&
        email.length &&
        validEmail &&
        patt.test(phone) &&
        checked
      ) {
        return false;
      } else {
        return true;
      }
    },
  },
  watch: {
    "newUser.email"() {
      let { email } = this.newUser;
      if (email.indexOf("@") >= 0 && email.indexOf(".") >= 0) {
        let start = email.indexOf("@") + 1;
        let end = email.indexOf(".");
        let emailClient = email.slice(start, end);
        if (emailClient == "gmail" || emailClient == "yahoo") {
          if (!this.privateEmailConfirmed) {
            this.showModal = true;
          }
        }
      }
    },
  },
  mixins: [isNumber],
  methods: {
    async submitUserDetails() {
      this.saveDetailsToLocalStorage();
      this.signingUserUp = true;
      // the backend requires the checked property to be a string
      this.newUser.checked = String(this.newUser.checked);
      let requestObject = this.newUser;
      console.log(this.newUser)
      try {
        let response = await this.$_signUpUser(requestObject);
        this.saveUserId(response.data.user.id);
        this.handleSuccessfulUserSignup();
        console.log(response);
      } catch (error) {
        this.signingUserUp = false;
        this.handleError(error);
      }
    },
    saveUserId(userId) {
      localStorage.setItem("userId", userId);
      this.$store.dispatch("saveUserId", userId);
    },
    handleSuccessfulUserSignup() {
      this.signingUserUp = false;
      this.$router.push("/signup/authentication");
    },
    saveDetailsToLocalStorage() {
      localStorage.setItem("account-owner", JSON.stringify(this.newUser));
    },
    editEmail() {
      this.newUser.email = "";
      this.showModal = false;
    },
    validatePhone(){
      alert("Phone is validating")
      let phone = this.newUser.mobile_no
      var patt = /[a-z]+/i

      if((patt.test(phone) || phone.length != 11)){
          this.userphoneerror = true
          this.userphoneerrormsg = "<ul class='text-red-500'><li>Only numeric characters required</li><li>Number must be 11 digits</li></ul>"
      }

      return patt.test(phone)
  }
  },
};
</script>

<style scoped>
.row div {
  padding-bottom: 3rem;
}
.vue-tel-input {
  padding-bottom: 0 !important;
  border: none !important;
  border-bottom: 1px solid rgba(82, 82, 82, 0.5) !important;
}
.vti__input:focus {
  outline: none;
}
.padding-bottom-sm {
  padding-bottom: 0 !important;
}
.main-form-area {
  margin: 3rem 0 0 0;
}
.have-account {
  padding-top: 2rem;
}
.sign-up--btn {
  width: 6rem;
  height: 2.5rem;
  border-radius: 3px;
  background: #747474;
}
.sign-up--btn:focus {
  outline: none;
}
.terms-service-agreement {
  margin: 1.5rem 0 3rem 0;
}
.terms-service-agreement .checkbox {
  padding-top: 10rem;
}
.terms-service-agreement .text {
  font-size: 14px;
  color: #343633;
}
.sign-up--cloudenly_btn {
  /* height: 2.5rem; */
  display: flex;
  justify-content: center;
  align-items: center;
  /* width: 25rem; */
  border-radius: 3px;
  margin-left: 2rem;
  padding: 0.6rem;
}
.sign-up--cloudenly_btn:focus {
  outline: none;
}
.btn-container {
  display: flex;
  /* justify-content: space-between; */
}
.button-wrapper button.confirm {
  border: 1px solid #f57a4d;
}
@media screen and (max-width: 768px) {
  .sign-up--cloudenly_btn {
    display: none;
  }
  .terms-service-agreement .text {
    padding-left: 0.15rem;
    padding-top: 0.5rem;
    font-size: 0.7rem;
    margin-bottom: 0;
  }
  .padding-bottom-sm {
    padding-bottom: 3rem !important;
  }
  .padding-bottom-sm:last-of-type {
    padding-bottom: 0 !important;
  }
}

@media screen and (max-width: 320px) {
  .terms-service-agreement .text {
    font-size: 0.6rem;
  }
}
</style>
